import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-[60vh] flex items-center justify-center px-4 py-16" }
const _hoisted_2 = { class: "w-full max-w-[640px] rounded-[2.4rem] border border-black/10 bg-white p-8 shadow-sm text-center space-y-4" }
const _hoisted_3 = { class: "m-0 text-[1.8rem] font-semibold text-black" }
const _hoisted_4 = { class: "m-0 text-[1.4rem] text-[color:var(--gray)]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('Sorry! The payment has not been completed')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('Please try again later')), 1),
      _createVNode(_component_router_link, {
        to: "/",
        class: "inline-flex items-center justify-center rounded-xl bg-black px-4 py-2 text-[1.3rem] font-semibold text-white transition hover:bg-black/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Continue Shopping')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}